import { Grid } from '@mui/material';

import { styled } from '@mui/material/styles';

const ResponsiveImg = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    height: '50px',
  },
  [theme.breakpoints.up('md')]: {
    height: '70px',
  },
}));

const ResponsiveMainImg = styled('img')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    height: '60px',
  },
  [theme.breakpoints.up('md')]: {
    height: '80px',
  },
}));

const ProposalViewAwards = () => (
  <Grid container spacing={2}>
    <Grid
      item
      sm={4}
      sx={{
        display: { xs: 'none', sm: 'block' },
        textAlign: { xs: 'center' },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ pl: 6 }}>
          <ResponsiveImg src="/images/awards/1.svg" alt="award" height="50" style={{ marginRight: '15%' }} />
        </Grid>
        <Grid item xs={6} sx={{ pr: 4 }}>
          <ResponsiveImg src="/images/awards/2.svg" alt="award" height="50" />
        </Grid>
      </Grid>
    </Grid>

    <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <ResponsiveMainImg src="/images/logo.svg" alt="AirMaxx" />
    </Grid>

    <Grid
      item
      xs={12}
      sm={4}
      sx={{ textAlign: { xs: 'center' } }}
    >
    <Grid container spacing={2}>
      <Grid item xs={6} sx={{ display: { sm: 'none' } }}>
        <ResponsiveImg src="/images/awards/1.svg" alt="award" height="50" style={{ marginRight: '15%' }} />
      </Grid>
      <Grid item xs={6} sx={{ display: { sm: 'none' } }}>
        <ResponsiveImg src="/images/awards/2.svg" alt="award" height="50" />
      </Grid>
      <Grid item xs={4}>
        <ResponsiveImg src="/images/awards/3.png" alt="award" height="50" />
      </Grid>
      <Grid item xs={4}>
        <ResponsiveImg src="/images/awards/4.svg" alt="award" height="50" />
      </Grid>
      <Grid item xs={4}>
        <ResponsiveImg src="/images/awards/5.svg" alt="award" height="50" />
      </Grid>
    </Grid>
    </Grid>
  </Grid>
);

export default ProposalViewAwards;
